import React, { useEffect, useState } from 'react';
import { BrowserRouter, Switch, useHistory, Redirect } from 'react-router-dom';
import { PrivateRoute } from './Private.routes';
import Home from '../Pages/Home';
import Movie from '../Pages/Movie';
import User from '../Pages/User';
import FilmProductionCompany from '../Pages/FilmProductionCompany';
import Header from '../Components/Header';
import AblProvider from '../Context';
import { useAblContext } from '../Hooks/useAblContext';
import AddMovie from '../Pages/AddMovie';
import { fromUnixTime, isAfter } from 'date-fns';
function HomeRoute() {
  const abl = useAblContext();
  const history = useHistory();
  useEffect(() => {
    const localStorageToken = localStorage.getItem('@authToken');
    if(localStorage){
      abl.saveToken(`bearer ${localStorageToken}` || "");
    }
    if(abl.token) {
      const { exp, role } = JSON.parse(atob(abl.token.split('.')[1]));
      const expireDate = fromUnixTime(exp);
      if(isAfter(new Date(), expireDate )){
        localStorage.removeItem('@authToken');
        abl.saveRoles("");
        abl.saveAuthenticated(false);
        return history.replace('/login');
      }
      abl.saveRoles(role[0]);
      abl.saveAuthenticated(true);
      return history.replace('/home');
    }
      abl.saveRoles("");
      abl.saveAuthenticated(false);
      return history.replace('/login');
  }, [])

    return(
      <>
          <BrowserRouter>
            <Header/>
              <hr/>
              <Switch>
                <PrivateRoute path="/home" exact initial component={Home} />
                <PrivateRoute path="/home/movie" component={Movie} />
                <PrivateRoute path="/home/producer" component={AddMovie} />
                <PrivateRoute path="/user" component={User} />
                <PrivateRoute path="/producer" component={FilmProductionCompany} />
                <Redirect to="/login"/>
              </Switch>
          </BrowserRouter>
      </>
    )
}

export default HomeRoute;
